module.exports = __webpack_public_path__ + "img/10878_L.b3205611.png";